/* istanbul ignore file */
export enum ErrorCodes {
  EventRolloutNotFound = "EventRolloutNotFound"
}
